import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { actionDrugsByPharmacyLoadData } from './actions';
import { NAMESPACE } from './helpers';
import { DrugsByPharmacyFilters, DrugsByPharmacyItem } from '../models';
import { startOfYear, endOfYear } from 'date-fns';

interface State {
  isLoading: boolean;
  isInit: boolean;
  isMounted: boolean;
  filters: DrugsByPharmacyFilters;
  data: DrugsByPharmacyItem[];
}

// N2c (T1): the page's defaults, what the filters button's badge counts against
export const drugsByPharmacyInitFilters = (): DrugsByPharmacyFilters => {
  const start = startOfYear(new Date());
  const end = endOfYear(new Date());

  return {
    dateRange: [start, end],
    pharmacyNames: [],
    drugNames: [],
  };
};

const initialState = (): State => {
  return {
    isLoading: false,
    isInit: false,
    isMounted: false,
    filters: drugsByPharmacyInitFilters(),
    data: [],
  };
};

const slice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    updateFilters: (state, action: PayloadAction<Partial<DrugsByPharmacyFilters>>) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    init: (state) => {
      state.isMounted = true;
    },
    destroy: (state) => {
      state.isMounted = false;
    },
  },
  extraReducers(build) {
    build
      .addCase(actionDrugsByPharmacyLoadData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(actionDrugsByPharmacyLoadData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(actionDrugsByPharmacyLoadData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
export const drugsByPharmacyReducer = slice.reducer;
export const drugsByPharmacyActions = slice.actions;
